<template>
  <div
    class="relative"
    :aria-busy="loading"
  >
    <div
      class="transition-opacity"
      :class="{ 'opacity-50 pointer-events-none': loading }"
    >
      <slot />
    </div>
    <transition name="sf-fade">
      <div
        v-if="loading"
        class="absolute inset-0 z-10 flex justify-center items-start pt-20"
        data-testid="loadingOverlay"
      >
        <SpinnerLoader
          class="sticky top-1/3"
          size="38px"
        />
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'LoadingOverlay' });

withDefaults(defineProps<{
  loading?: boolean;
}>(), {
  loading: false,
});
</script>
